import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { CostosOperacionCreditoController } from './costos-operacion-credito.controller';
import { CostosOperacionCreditoService } from './costos-operacion-credito.service';

@Module({
  imports: [PrismaModule],
  controllers: [CostosOperacionCreditoController],
  providers: [CostosOperacionCreditoService],
  exports: [CostosOperacionCreditoService],
})
export class CostosOperacionCreditoModule {}
